import { stringArrayToSelectOptions } from '@/utils/misc.ts'
import { Department } from '@/common/types/work-info.def.ts'

export const TeamFunction = {
  GeneralNotification: 'General Notification',
  Checklist: 'Checklist',
}

export const TeamFunctionOptions = stringArrayToSelectOptions(Object.values(TeamFunction))

export const FunctionalTeam = {
  HumanCapital: Department.HumanCapital,
  Administration: Department.Administration,
  Finance: Department.Finance,
  Compliance: Department.Compliance,
  IT: 'IT',
  ExecutiveAdmin: 'Executive Admin',
  DataManagementTeam: 'Data Management Team',
}

export const FunctionalTeamOptions = stringArrayToSelectOptions(Object.values(FunctionalTeam))